import { LayoutModule } from '@angular/cdk/layout';
import { CdkTableModule } from '@angular/cdk/table';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HdmuiComponentsModule, provideHdmui } from '@heidelberg/hdmui-angular';
import { FilterComponent } from './components/filter/filter.component';

import { MatBadgeModule } from '@angular/material/badge';
import { MatDividerModule } from '@angular/material/divider';
import { MatStepperModule } from '@angular/material/stepper';
import { TranslateModule } from '@ngx-translate/core';
import { CornerHelpComponent } from './components/corner-help/corner-help.component';
import { LoadMoreComponent } from './components/load-more/load-more.component';
import { UserComponent } from './components/user.component';
import { YearMonthPickerComponent } from './components/year-month-picker.component';
import { AboutDialogComponent } from './dialog/about-dialog.component';
import { ConfirmDialogComponent } from './dialog/confirm-dialog.component';
import { DeleteDialogComponent } from './dialog/delete-dialog.component';
import { StepEnteredDirective } from './directives/step-entered.directive';
import { OpenDialogMarkerPipe } from './open-dialog-marker.pipe';
import { EmptyPipe } from './pipes/empty/empty.pipe';
import { TimestampPipe } from './timestamp.pipe';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule, FormsModule,
    TranslateModule.forChild(),
    LayoutModule,
    HdmuiComponentsModule,
    MatToolbarModule,
    MatDialogModule,
    MatSidenavModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatListModule,
    MatChipsModule,
    MatSelectModule,
    MatRadioModule,
    MatTableModule,
    MatTabsModule,
    CdkTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatStepperModule,
    MatBadgeModule,
    MatDividerModule,
  ],
  declarations: [OpenDialogMarkerPipe,
    ConfirmDialogComponent, DeleteDialogComponent, EmptyPipe,
    AboutDialogComponent, TimestampPipe,
    YearMonthPickerComponent,
    UserComponent, FilterComponent, LoadMoreComponent, CornerHelpComponent,
    StepEnteredDirective,
  ],

  exports: [
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    LayoutModule,
    HdmuiComponentsModule,
    MatToolbarModule,
    MatDialogModule,
    MatSidenavModule,
    MatInputModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    MatListModule,
    MatChipsModule,
    MatSelectModule,
    MatRadioModule,
    MatTableModule,
    MatTabsModule,
    CdkTableModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatSortModule,
    MatDatepickerModule,
    MatAutocompleteModule,
    MatExpansionModule,
    MatSnackBarModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatStepperModule,

    OpenDialogMarkerPipe,
    ConfirmDialogComponent,
    AboutDialogComponent,
    EmptyPipe,
    TimestampPipe,
    YearMonthPickerComponent,
    UserComponent,
    FilterComponent,
    LoadMoreComponent,
    CornerHelpComponent,
    StepEnteredDirective,
  ],
  providers: [
    provideHdmui()
  ]
})
export class UiSharedModule { }
